module.exports = __webpack_public_path__ + "static/editorial-new-regular-2b94d13d81b0018cec0191d469675906.woff";